<template>
  <div>
    <el-card>
      <div class="flex flex-align-center flex-justify-between">
        <div class="flex flex-align-center flex-wrap gap-10 flex-1">
          <div class="flex flex-align-center gap-10">
            <div class="keyLabel">关键字：</div>
            <el-input v-model.trim="keywords" style="width:250px" placeholder="推手手机号"></el-input>
          </div>
          <el-button type="primary" @click="handleCurrentChange(1)">查询</el-button>
          <buttonPermissions :datas="'upStatisticsExport'">
            <el-button @click="exportFile">导出</el-button>
          </buttonPermissions>
        </div>
        <el-popover placement="bottom-end" trigger="hover">
          <div class="flex flex-column gap-20" style="width:445px">
            <div class="flex flex-align-start">
              <li></li>
              <div>
                <span class="font-bold">累计直推人数：</span>与推手存在直接推荐关系的人数
              </div>
            </div>
            <div class="flex flex-align-start">
              <li></li>
              <div>
                <span class="font-bold">个人+直推业绩：</span>=推手个人销售业绩+直推推手个人销售业绩；订单支付成功后按订单实付金额(不含运费)计入；业绩核算剔除退款成功部分
              </div>
            </div>
            <div class="flex flex-align-start">
              <li></li>
              <div>
                <span class="font-bold">连续3个月：</span>近连续3个自然月的数据。比如当前为4月，则统计1月，2月，3月的数据
              </div>
            </div>
            <div class="flex flex-align-start">
              <li></li>
              <div>
                <span class="font-bold">连续6个月：</span>近连续6个自然月的数据。比如当前为2025年4月，则统计1月，2月，3月，以及2024年10月、11月、12月的数据
              </div>
            </div>
          </div>
          <div slot="reference" class="font-14 color-606266">统计说明 <i class="el-icon-warning-outline"></i> </div>
        </el-popover>
      </div>
      <div class="margin-top-10">
        <el-table :data="tablelist" v-loading="tableloading">
          <el-table-column prop="" label="推手信息" min-width="150">
            <template slot-scope="scope">
              <div>
                <div class="ellipsis">
                  {{scope.row.Name||scope.row.WxNickname}}
                </div>
                <div>
                  {{scope.row.Phone}}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="连续3个月累计直推人数">
            <template slot-scope="scope">
              <div>
                {{scope.row.ThirdRecommendCount}}人
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="连续3个月个人+直推业绩">
            <template slot-scope="scope">
              <div>
                {{scope.row.ThirdPerformanceMoney}}元
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="连续6个月累计直推人数">
            <template slot-scope="scope">
              <div>
                {{scope.row.SixRecommendCount}}人
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="连续6个月个人+直推业绩">
            <template slot-scope="scope">
              <div>
                {{scope.row.SixPerformanceMoney}}元
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="操作" width="120">
            <template slot-scope="scope">
              <el-button type="text" @click="toUp(scope.row)">去升级</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align:right" class="margin-top-10" v-if="total">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import config from '@/config/index'
import buttonPermissions from '@/components/buttonPermissions';
import {
  tianXianUpgradeStatisticslist
} from "@/api/sv3.0.0"
export default {
  components: {
    buttonPermissions
  },
  data () {
    return {
      keywords:'',
      tablelist:[],
      tableloading:false,
      currentPage:1,
      pageSize:20,
      total:0
    }
  },
  mounted(){
    this.gettablelist()
  }, 
  methods: {
    toUp(row){
      let headsUrls = process.env.NODE_ENV == 'production' ? 'index.html#' : ''
			let url = config.GO_URL + headsUrls + '/agent/agentmanagelist?phone=' + row.Phone;
			window.open(url)
      // console.log(1)
      // this.$router.push({
      //   name:'agentmanagelist',
      //   params:{
      //     phone:row.Phone
      //   }
      // })

    },
    handleSizeChange(e){
      this.currentPage = 1
      this.pageSize = e
      this.gettablelist()
    },
    handleCurrentChange(e){
      this.currentPage = e
      this.gettablelist()
    },
    async gettablelist(){
      try{
        this.tableloading = true
        let res = await tianXianUpgradeStatisticslist({
          Keywords:this.keywords,
          Skip:(this.currentPage-1)*this.pageSize,
          Take:this.pageSize
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    },
    exportFile(){
      let url = location.origin + '/pc/tianXianUpgradeStatistics/export'
      url += '?Keywords='+encodeURI(this.keywords)
      window.open(url)
    }
  }
}
</script>

<style lang='less' scoped>

</style>